<template>
  <div class="home-title-area">
    <component :is="tag" class="home-title">{{ title }}</component>
    <p v-if="subtitle" class="home-subtitle">{{ subtitle }}</p>
  </div>
</template>

<script setup lang="ts">
/**
 * 支給デザインの `home-title-area`（セクション見出し）。
 *
 * 支給トップでは3パターン出る。
 * - `h2.home-title` のみ（お知らせ）
 * - `h2.home-title` ＋ `p.home-subtitle`（お悩み診断／人気の商品ランキング／ご愛用者様の声／お役立ちコラム／定期コース特典）
 * - `p.home-title` のみ（お買い物サポート。直下に別の `h2` があるため見出しレベルの重複を避けている）
 *
 * 中央寄せは支給CSSが親セクション（`.sec_footer-support` 等）で決めるので、prop は持たせない。
 */
type Props = {
  title: string;
  subtitle?: string;
  /** 見出しのタグ。既定は `h2`。同一セクションに別の `h2` がある場合だけ `p` にする */
  tag?: 'h2' | 'h3' | 'p';
};
withDefaults(defineProps<Props>(), { subtitle: '', tag: 'h2' });
</script>
